export enum AnnotationAction {
  add = 'add',
  modify = 'modify',
  delete = 'delete'
}
